export const SET_TOKEN = 'SET_TOKEN';
export const FAILED_GET_TOKEN = 'FAILED_GET_TOKEN';
export const FAILED_VERIFY_TOKEN = 'FAILED_VERIFY_TOKEN';
export const SET_USER = 'SET_USER';
export const FAILED_GET_USER = 'FAILED_GET_USER';
export const RESET_REDIRECT_STATE = 'RESET_REDIRECT_STATE';
export const SET_DME_CLIENTS = 'SET_DME_CLIENTS';
export const FAILED_GET_DME_CLIENTS = 'FAILED_GET_DME_CLIENTS';
export const SET_CLIENT_PK = 'SET_CLIENT_PK';
export const SUCCESS_RESET_PASSWORD = 'SUCCESS_RESET_PASSWORD';
export const FAILED_RESET_PASSWORD = 'FAILED_RESET_PASSWORD';
export const SUCCESS_RESET_PASSWORD_CONFIRM = 'SUCCESS_RESET_PASSWORD_CONFIRM';
export const FAILED_RESET_PASSWORD_CONFIRM = 'FAILED_RESET_PASSWORD_CONFIRM';
export const LOGOUT = 'LOGOUT';
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';



// WEBPACK FOOTER //
// ./src/state/constants/authConstants.js